import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationOrders(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.ORDERS, { keyPrefix });

  return t;
}

export default useTranslationOrders;
